import React, { lazy, Suspense } from 'react';
import useMedia from 'hooks/useMedia';
import Loader, { Variant as LoaderVariant } from 'components/Loader';
import { useMatch } from 'react-router-dom';

const AppShellMobile = lazy(() => import('./AppShell.mobile'));
const AppShellDesktop = lazy(() => import('./AppShell.desktop'));

const AppShell: React.FC<any> = (props) => {
  const { isMobile } = useMedia();
  const isSign = useMatch('/sign/:signId');
  const isSignCombined = useMatch('/sign-combined/:signId');
  const isFintiProposal = useMatch('/jobs/:jobId/finti_proposal');

  if (isSign || isSignCombined || isFintiProposal) {
    return <div className="h-screen">{props?.children}</div>;
  }

  return (
    <Suspense
      fallback={
        <Loader
          variant={LoaderVariant.RoofLoader}
          label="Loading. Please wait..."
        />
      }
    >
      {isMobile ? (
        <AppShellMobile {...props} />
      ) : (
        <AppShellDesktop {...props} />
      )}
    </Suspense>
  );
};

export default AppShell;
